import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import React from 'react';

import { propTypesDataVideo } from './Video.proptypes';

import Video from '../../../../ui/Atoms/Video';

import { DocumentType } from '../../../constants/Enums';
import * as S from './Video.styles';

export const VideoSlice = ({ slice, documentType }) => {
  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const {
    video_slice_id: id,
    video_id: videoId,
    video_title: videoTitle,
    video_caption: videoCaption,
    has_control: hasControl,
  } = data || '';

  const hasTitle =
    videoTitle &&
    (documentType === DocumentType.POST || documentType === DocumentType.EVENT);
  const hasCaption =
    videoCaption &&
    (documentType === DocumentType.POST || documentType === DocumentType.EVENT);

  const isSquareVideo =
    documentType === DocumentType.PAGE ||
    documentType === DocumentType.TESTIMONIAL;

  if (!videoId) {
    Sentry.captureMessage('Error: missing required data in Video slice');
    return null;
  }

  return (
    <S.Video id={id} isSquareVideo={isSquareVideo}>
      {hasTitle && <S.Title>{videoTitle}</S.Title>}
      <S.VideoWrapper isSquareVideo={isSquareVideo}>
        <Video allowControl={hasControl} videoId={videoId} />
        {hasCaption && <S.Caption>{videoCaption}</S.Caption>}
      </S.VideoWrapper>
    </S.Video>
  );
};

VideoSlice.propTypes = {
  /**
   * Document type.
   */
  documentType: PropTypes.string,
  /**
   * Content of the CTA slice.
   */
  slice: PropTypes.shape(propTypesDataVideo),
};
